/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountInventoryInfoAccountInventoryItems model module.
 * @module model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems
 * @version 1.0
 */
class AccountControllerDtoAccountInventoryInfoAccountInventoryItems {
    /**
     * Constructs a new <code>AccountControllerDtoAccountInventoryInfoAccountInventoryItems</code>.
     * @alias module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems
     */
    constructor() { 
        
        AccountControllerDtoAccountInventoryInfoAccountInventoryItems.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountInventoryInfoAccountInventoryItems</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountInventoryInfoAccountInventoryItems} The populated <code>AccountControllerDtoAccountInventoryInfoAccountInventoryItems</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountInventoryInfoAccountInventoryItems();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('gemEffect')) {
                obj['gemEffect'] = ApiClient.convertToType(data['gemEffect'], 'Number');
            }
            if (data.hasOwnProperty('gemEffectValue')) {
                obj['gemEffectValue'] = ApiClient.convertToType(data['gemEffectValue'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryItems</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountInventoryInfoAccountInventoryItems</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} itemId
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryItems.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryItems.prototype['itemName'] = undefined;

/**
 * @member {Number} gemEffect
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryItems.prototype['gemEffect'] = undefined;

/**
 * @member {Number} gemEffectValue
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryItems.prototype['gemEffectValue'] = undefined;

/**
 * @member {Number} itemCount
 */
AccountControllerDtoAccountInventoryInfoAccountInventoryItems.prototype['itemCount'] = undefined;






export default AccountControllerDtoAccountInventoryInfoAccountInventoryItems;

